import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_AD, ROLE_AD_AS, ROLE_BL } from "../../../common/constant";

import { faUndo } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import { ButtonGroup, ButtonToolbar } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { LOAD_PREVIOUS_DATA_ENABLED } from "../../../ducks/surveyEditor";
import ObjectUtils from "../../../utils/ObjectUtils";
import SurveyUtils from "../../../utils/SurveyUtils";
import { visibleCollection } from "../../../utils/TriggerUtil";
import ActivityMonitoringQuestion from "./questions/ActivityMonitoringQuestion";
import questionComponents from "./questions/questionComponents";

const { findByObjectProp } = ObjectUtils;

/**
 * The page component on survey-view- represents a page of survey where questions are rendered.
 */
const Page = ({
  surveyResult,
  surveyTemplate,
  surveyProgram,
  questionValidations,
  setQuestionAnswer,
  addQuestionAnswer,
  removeQuestionAnswer,
  endLoading,
  beginLoading,
  addRow,
  importRows,
  deleteRow,
  deleteRows,
  uploadFiles,
  downloadFile,
  selectFiles,
  loadPredefinedList,
  predefinedList,
  currPage,
  reorderQuestionRow,
  loadPreviousPeriodQuestionAnswers,
  downloadCSVTemplate,
  disabled,
  monitoringEditOnly,
  isActivityMonitoring,
  validateQuestionAnswer,
  pageTemplate,
  triggerState,
  roles
}) => {
  const result = [];
  const questions = visibleCollection(pageTemplate.questions, triggerState);

  let BL = roles?.includes(ROLE_BL);
  let AD = roles?.includes(ROLE_AD) || roles?.includes(ROLE_AD_AS);

  for (let i = 0; i < questions.length; i++) {
    const question = questions[i];

    const validation = questionValidations[question.name];
    const qComponent = ObjectUtils.findByObjectProp(questionComponents, "type", question.type);

    let element;

    if (qComponent.component) {
      const questionAnswer = findByObjectProp(surveyResult.questions, "name", question.name);
      element = React.cloneElement(qComponent.component, {
        key: currPage.name + i,
        disabled,
        monitoringEditOnly,
        isActivityMonitoring,
        question,
        surveyTemplate,
        questionAnswer,
        surveyResult,
        validation,
        setQuestionAnswer,
        addQuestionAnswer,
        removeQuestionAnswer,
        addRow,
        importRows,
        deleteRow,
        deleteRows,
        uploadFiles,
        downloadFile,
        selectFiles,
        loadPredefinedList,
        predefinedList,
        currPage,
        reorderQuestionRow,
        endLoading,
        beginLoading,
        loadPreviousPeriodQuestionAnswers,
        downloadCSVTemplate,
        validateCommentAnswer: true,
        validateQuestionAnswer
      });
    } else {
      if (question.type === "activityList") {
        element = (
          <ActivityMonitoringQuestion
            key={currPage.name + i}
            question={question}
            answers={surveyResult?.activityMonitoring}
          />
        );
      } else {
        element = <h5 key={i}>Unsupported question type: {question.type}</h5>;
      }
    }
    result.push(element);
    if (question[LOAD_PREVIOUS_DATA_ENABLED] && !(BL || AD)) {
      result.push(
        <ButtonToolbar>
          <ButtonGroup>
            <Button
              key={"loadPrevDataButton" + currPage.name + i}
              variant="secondary"
              disabled={disabled}
              onClick={() => loadPreviousPeriodQuestionAnswers(question)}
            >
              <FontAwesomeIcon icon={faUndo} className="me-2" />
              <FormattedMessage
                id={
                  SurveyUtils.isSemesterTypeProgram(surveyProgram?.name)
                    ? "user.surveyView.table.loadPreviousReportQuestionAnswers"
                    : "user.surveyView.table.loadPrevPeriodQuestionAnswers"
                }
              />
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      );
    }
  }

  return result;
};

Page.propTypes = {
  pageTemplate: PropTypes.object.isRequired,
  setQuestionAnswer: PropTypes.func,
  surveyResult: PropTypes.object.isRequired,
  surveyTemplate: PropTypes.object,
  surveyProgram: PropTypes.object,
  questionValidations: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  triggerState: PropTypes.array,
  roles: PropTypes.array,
  currPage: PropTypes.object,
  predefinedList: PropTypes.object,
  loadPredefinedList: PropTypes.func,
  selectFiles: PropTypes.func,
  downloadFile: PropTypes.func,
  endLoading: PropTypes.func,
  beginLoading: PropTypes.func,
  uploadFiles: PropTypes.func,
  deleteRow: PropTypes.func,
  deleteRows: PropTypes.func,
  loadPreviousPeriodQuestionAnswers: PropTypes.func,
  addRow: PropTypes.func,
  importRows: PropTypes.func,
  addQuestionAnswer: PropTypes.func,
  removeQuestionAnswer: PropTypes.func,
  reorderQuestionRow: PropTypes.func,
  validateCommentAnswer: PropTypes.bool,
  validateQuestionAnswer: PropTypes.func,
  isActivityMonitoring: PropTypes.bool,
  monitoringEditOnly: PropTypes.bool
};

export default injectIntl(Page);
